import React, { useContext } from "react";
import { Column, Row, AlertBox } from "@vp/swan";
import TokenEngine from "@vp/vp-js-token-engine";
import { Translations } from "../utils/Translation";

import { IssuesWrapper } from "@vp/gatsby-pages-issues-tracker-plugin";
import { PurifiedComponent } from "./PurifiedComponent";
import { BffDataContext } from "../contexts/BffDataContextProvider";

interface AvailabilityAlertBoxProps {
  breadcrumbs:
    | {
        url: string;
        name: string;
      }[]
    | undefined;
}

const AvailabilityAlertBox = (props: AvailabilityAlertBoxProps) => {
  const { breadcrumbs } = props;
  const { temporarilyOutOfStock } = useContext(BffDataContext);

  const categoryPageLink = breadcrumbs?.[breadcrumbs?.length - 2];

  const translations = Translations.getInstance();
  const outOfStockBanner = translations.getTranslationEntry("outOfStockBanner");
  const availabilityAlertBox = translations.getTranslationEntry("availabilityAlertBox");
  let bannerContent = availabilityAlertBox;
  if (outOfStockBanner && outOfStockBanner && categoryPageLink?.url) {
    const tokenEngine = new TokenEngine();
    bannerContent = tokenEngine.replace(outOfStockBanner, {
      OpenAnchor: `<a href="${categoryPageLink.url}">`,
      CloseAnchor: "</a>",
    });
  }

  if (!temporarilyOutOfStock) {
    return <></>;
  }

  return (
    <Row>
      <Column span={12}>
        <AlertBox skin="warning">
          <IssuesWrapper targetNodes={[outOfStockBanner]} elementName="Out of stock banner">
            <PurifiedComponent component="p" content={bannerContent} />
          </IssuesWrapper>
        </AlertBox>
      </Column>
    </Row>
  );
};

export default AvailabilityAlertBox;
